/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React from 'react';

function BulkInvoiceListing() {
    return (
        <div className="py-6 main-screen">
            <div className="flex justify-between items-center">
                <div className="flex items-center">
                    <a href="admin-bulkOffer-viewSubscriiber-order-listing.html">
                        <img src="/images/Icon-feather-arrow-left.svg" alt="icon" className="pr-4 cursor-pointer" />
                    </a>
                    <h5 className="text-xs4 font-normal text-[#555259]">View Invoice Report</h5>
                </div>
                <div className="flex items-center">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{ border: '2px solid #E9EDF4' }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input type="text" name="search" id="search" className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]" placeholder="Search" />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg">
                            Export
                        </button>
                        <ul className="dropdown-menu sm:min-w-[140px] min-w-[120px] absolute hidden bg-[#FFFFFF] rounded-lg shadow-s2 z-[40] sm:p-3.5 p-1.5" aria-labelledby="exportDropdown">
                            <li className=" sm:py-1 py-0.5 export border-b border-[#D8D8D8]">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#">CSV</a>
                            </li>
                            <li className=" sm:py-1 py-0.5 border-b border-[#D8D8D8]">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#">PDF</a>
                            </li>
                            <li className=" sm:py-1 py-0.5">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#">Excel</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="overflow-auto dropdown-menu pt-[18px] pb-7 relative z-[7]">
                <table className="w-full table-auto relative">
                    <thead>
                        <tr className="bg-[#555259] h-10">
                            <th className="py-4 px-6 rounded-bl-lg rounded-tl-lg min-w-[160px] text-start bg-[#555259] sticky top-0 left-0" scope="col">
                                <span className="text-sm29 font-bold text-[#FFFFFF]">
                                    Invoice No.
                                </span>
                            </th>
                            <th scope="col" className="py-4 px-7 min-w-[200px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                    Invoice Date
                                    <a href="#" className="pl-[5px]">
                                        <img src="/images/Group-9083.svg" alt="" />
                                    </a>
                                </span>
                            </th>
                            <th scope="col" className="py-4 px-7 min-w-[182px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                    E-way Bill No.
                                </span>
                            </th>
                            <th scope="col" className="py-4 px-7 min-w-[160px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                    Category
                                </span>
                            </th>
                            <th scope="col" className="py-4 px-7 min-w-[230px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                    Transporter Name
                                </span>
                            </th>
                            <th scope="col" className="py-4 px-7 min-w-[200px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                    Indent Number
                                </span>
                            </th>
                            <th scope="col" className="py-4 px-7 min-w-[200px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                    Order Date
                                    <a href="#" className="pl-[5px]">
                                        <img src="/images/Group-9083.svg" alt="" />
                                    </a>
                                </span>
                            </th>
                            <th scope="col" className="py-4 px-7 min-w-[210px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                    Order Acceptance No.
                                </span>
                            </th>
                            <th scope="col" className="py-4 px-7 min-w-[170px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                    Shipped From
                                </span>
                            </th>
                            <th scope="col" className="py-4 px-7 min-w-[164px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                    Shipped To
                                </span>
                            </th>
                            <th scope="col" className="py-4 px-7 min-w-[180px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                    Invoice Value
                                    <a href="#" className="pl-[5px]">
                                        <img src="/images/Group-9083.svg" alt="" />
                                    </a>
                                </span>
                            </th>
                            <th scope="col" className="py-4 px-7 min-w-[180px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                    Payment Status
                                </span>
                            </th>
                            <th scope="col" className="py-4 px-7 min-w-[80px] text-center rounded-tr-lg rounded-br-lg bg-[#555259] sticky top-0 right-0" />
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                            <td
                                className="text-sm font-normal text-[#090406] py-4 px-7 text-start sticky top-0 left-0"
                                style={{ background: ' rgba(255, 255, 255, 0.45)', backdropFilter: ' blur(5.5px)' }}
                            >
                                587458
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                09-Dec-2022 23:44:27
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                458769850
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                Equipments
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                Others Road Transportation
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                OD220000012-2
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                09-Dec-2022 23:44:27
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                1233454325
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                Bhivandi
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                Pune
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                ₹4,58,2145.00
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                Paid
                            </td>
                            <td
                                className="py-4 px-7 sticky top-0 right-0 z-[10]"
                                style={{ background: ' rgba(255, 255, 255, 0.45)', backdropFilter: ' blur(5.5px)' }}
                            >
                                <div className="dropdown relative">
                                    <button className="dropdown-toggle" type="button" id="dropdownMenuButton111" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img src="/images/more-vertical.svg" alt="icon" className="cursor-pointer" />
                                    </button>
                                    <ul className="dropdown-menu min-w-max absolute hidden bg-[#FFFFFF] rounded-[10px] shadow-s2 p-1" aria-labelledby="dropdownMenuButton111">
                                        <li className="px-4 py-2" data-bs-toggle="modal" data-bs-target="#view-and-download">
                                            <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="#">View and Download</a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="flex items-center justify-center pt-3">
                <a href="#" className="mr-5 bg-[#FFFFFF] rounded-[5px] w-[27px] h-[27px] flex justify-center">
                    <img src="/images/chevrons-left.svg" alt="icon" className="w-[8px]" />
                </a>
                <div>
                    <a
                        href="#"
                        className="text-xs font-regular text-[#555259] px-2 bg-[#FFFFFF] rounded-[5px] w-5 h-5 inline-flex justify-center items-center"
                    >
                        1

                    </a>
                    <a
                        href="#"
                        className="text-xs font-regular text-[#555259] ml-2 px-2 border border-transparent rounded-[5px] w-5 h-5 inline-flex justify-center items-center hover:bg-[#F2F2F3]"
                    >
                        2

                    </a>
                    <a
                        href="#"
                        className="text-xs font-regular text-[#555259] ml-2 px-2 border border-transparent rounded-[5px] w-5 h-5 inline-flex justify-center items-center hover:bg-[#F2F2F3]"
                    >
                        3

                    </a>
                    <a
                        href="#"
                        className="text-xs font-regular text-[#555259] ml-2 px-2 border border-transparent rounded-[5px] w-5 h-5 inline-flex justify-center items-center hover:bg-[#F2F2F3]"
                    >
                        4

                    </a>
                </div>
                <a href="#" className="ml-5">
                    <img src="/images/Right-angle-icon.svg" alt="icon" />
                </a>
            </div>
        </div>
    );
}

export default BulkInvoiceListing;
